export default {
  MAP: 'MAP',
  LIST: 'LIST'
};